import clsx from "clsx";
import { useEffect, useState } from "react";

import {
  getTeamInitials,
  isValidImage,
} from "@smart/bridge-intake-components-dom";
import { ProgressCircle } from "@smart/itops-sb-design-system-dom";

type LogoDisplayProps = {
  url: string | null | undefined;
  firmName: string;
  loading?: boolean;
  error?: boolean;
};

export const LogoDisplay = ({
  url,
  firmName,
  loading = false,
  error,
}: LogoDisplayProps) => {
  const [isImageValid, setIsImageValid] = useState(!!url);

  useEffect(() => {
    if (url) {
      isValidImage(url)
        .then(setIsImageValid)
        .catch(() => setIsImageValid(false));
    } else {
      setIsImageValid(false);
    }
  }, [url]);

  return (
    <div
      className={clsx(
        "relative w-full h-full rounded overflow-hidden",
        error && "shadow-error border border-red-550",
      )}
    >
      {isImageValid && url ? (
        <img
          src={url}
          alt="Logo"
          className="w-full h-full object-contain rounded"
          onError={() => setIsImageValid(false)}
        />
      ) : (
        <div className="flex items-center justify-center text-paragraph font-semibold rounded select-none bg-neutral-200 overflow-hidden w-full h-full">
          {getTeamInitials(firmName)}
        </div>
      )}
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center bg-neutral-400/50 rounded">
          <ProgressCircle size="xSmall" />
        </div>
      )}
    </div>
  );
};
